// src/features/sda-import/sdaImportAPI.js
import { doGetQCXRequest } from '../../utils/api/domain/domain-api-utils';

async function fetchAll(tipo) {
  return doGetQCXRequest([`tabelasda/listagem?tipo=${tipo}`]);
}

export default fetchAll;
